import React, { useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";

import { useAuth } from "./AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import image from "black-white-logo.png";
import "../assets/css/login.css";
import NotificationComponent from "components/Alert/alert";
import { useTranslation } from "../hooks/useTranslation";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";

const LogIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const notificationComponentRef = useRef(new NotificationComponent());
  const { login, token } = useAuth();
  const navigate = useNavigate();
  const t = useTranslation();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    const loginStatus = await login(email, password);
    if (loginStatus) {
      navigate("/admin/dashboard", { replace: true });
    } else {
      notificationComponentRef.current.showNotification(
        t("login.errorMessage"),
        "danger"
      );
    }
  };

  const handleSignUp = async (e) => {
    notificationComponentRef.current.showNotification(
      t("login.registerUnavailable"),
      "danger"
    );
    setShowRegisterForm(!showRegisterForm);
    setEmail("");
    setPassword("");
    setBusinessName("");
    e.preventDefault(); // Prevent the default form submission

    // Add your sign-up logic here
  };

  if (token) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <>
      <div className="content login-container">
        <NotificationComponent ref={notificationComponentRef} />
        <Row className="justify-content-center">
          <Card>
            <CardHeader>
              <Col
                style={{ textAlign: "center" }}
                className="imageContainer"
                md="12"
              >
                <img style={{ width: "45%" }} alt="..." src={image} />
              </Col>
              <Col
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
                md="12"
              >
                <span>{t("login.title")}</span>
                <LanguageSwitcher showLabel={false} />
              </Col>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleLogin}>
                <Row>
                  {showRegisterForm && (
                    <Col sm="12">
                      <FormGroup>
                        <Label for="businessName">{t("login.businessName")}</Label>
                        <Input
                          value={businessName}
                          onChange={(e) => setBusinessName(e.target.value)}
                          placeholder={t("login.businessNamePlaceholder")}
                          required
                        />
                      </FormGroup>
                    </Col>
                  )}

                  <Col sm="12">
                    <FormGroup>
                      <Label for="email">{t("login.email")}</Label>
                      <Input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={t("login.emailPlaceholder")}
                        type="email"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col className sm="12">
                    <FormGroup>
                      <label>{t("login.password")}</label>
                      <Input
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder={t("login.passwordPlaceholder")}
                        type="password"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    {!showRegisterForm ? (
                      <Button
                        className="col-md-12 btn-fill"
                        color="primary"
                        type="submit"
                      >
                        {t("login.loginButton")}
                      </Button>
                    ) : (
                      <Button
                        className="col-md-12 btn-fill"
                        color="primary"
                        type="submit"
                      >
                        {t("login.signUpButton")}
                      </Button>
                    )}
                  </Col>
                  <Col sm="12" className="text-center mt-4 mb-4">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <hr style={{ flexGrow: 1 }} />
                      <span style={{ padding: "0 10px", fontSize: "18px" }}>
                        {t("login.or")}
                      </span>
                      <hr style={{ flexGrow: 1 }} />
                    </div>
                  </Col>
                  <Col md="12 mb-5">
                    {!showRegisterForm ? (
                      <Button
                        className="col-md-12 btn-fill"
                        color="success"
                        onClick={handleSignUp}
                      >
                        {t("login.createAccount")}
                      </Button>
                    ) : (
                      <Button
                        className="col-md-12 btn-fill"
                        color="success"
                        onClick={handleSignUp}
                      >
                        {t("login.loginExisting")}
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          {/* </div> */}
          {/* ... (Existing profile card) */}
        </Row>
      </div>
    </>
  );
};

export default LogIn;
